export default "__VITE_ASSET__CQNR_baP__"